module.exports = __webpack_public_path__ + "static/media/logo.876cbd71.svg";